angular.module("ainapp")
    .controller("purchaseDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Purchase Dashboard";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.top10CustomersFun = function () {
                $("#top10chart").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.TopVendorsByPurchase
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        type: "donut",
                        startAngle: 150
                    },
                    series: [{
                        name: "2011",
                        data: $scope.Top10Customers,
                    }],
                    tooltip: {
                        visible: true,
                        //template: "#= category # (#= series.name #): #= value #%",
                        template: function (e) {
                            return e.category + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });
                $("#top10chart2").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.TopVendorsByPurchase
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        type: "donut",
                        startAngle: 150
                    },
                    series: [{
                        name: "2011",
                        data: $scope.Top10Customers,
                    }],
                    tooltip: {
                        visible: true,
                        // template: "#= category # (#= series.name #): #= value #%"
                        template: function (e) {
                            return e.category + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });

            }

            $scope.mostSalesItemsFun = function () {

                $("#mostSellingChart").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.MostPurchasingItems
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        labels: {
                            visible: true,
                            background: "transparent",
                            // template: "#= category #: \n #= value#",
                            template: function (e) {
                                return e.category + ": \n" + $scope.convertNo(e.value);
                            }
                        }
                    },
                    series: [{
                        type: "pie",
                        startAngle: 150,
                        data: $scope.MostSellingItems,
                    }],
                    tooltip: {
                        visible: true,
                        format: "{0}",
                        template: function (e) {
                            return e.category + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });
                $("#mostSellingChart2").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.MostPurchasingItems
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        labels: {
                            visible: true,
                            background: "transparent",
                            //template: "#= category #: \n #= value#",
                            template: function (e) {
                                return e.category + ": \n" + $scope.convertNo(e.value);
                            }
                        }
                    },
                    series: [{
                        type: "pie",
                        startAngle: 150,
                        data: $scope.MostSellingItems,
                    }],
                    tooltip: {
                        visible: true,
                        //format: "{0}",
                        template: function (e) {
                            return e.category + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });
            }

            $scope.MonthlySalesChartFun = function () {

                $("#monthlysalesChart").kendoChart({
                    title: {
                        text: $scope.LanguageData.MonthlyPurchase
                    },
                    series: $scope.MonthlySalesChartData.series,
                    categoryAxis: {
                        categories: $scope.MonthlySalesChartData.categories
                    },
                    valueAxis: {
                        labels: {
                            //template: "#= kendo.toString(value, 'n0') #"
                            template: function (e) {
                                return $scope.convertNo(e.value);
                            }
                        }
                    },
                    tooltip: {
                        visible: true,
                        //template: "#= series.name #: #= value #",
                        template: function (e) {
                            return e.series.name + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });
                $("#monthlysalesChart2").kendoChart({
                    title: {
                        text: $scope.LanguageData.MonthlyPurchase
                    },
                    series: $scope.MonthlySalesChartData.series,
                    categoryAxis: {
                        categories: $scope.MonthlySalesChartData.categories
                    },
                    valueAxis: {
                        labels: {
                            //template: "#= kendo.toString(value, 'n0') #"
                            template: function (e) {
                                return $scope.convertNo(e.value);
                            }
                        }
                    },
                    tooltip: {
                        visible: true,
                        // template: "#= series.name #: #= value #",
                        template: function (e) {
                            return e.series.name + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });

            }


            $scope.SalePurchaseAnalysisFun = function () {

                $("#salesPurchaseAnalysisChart").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.SalesPurchaseAnalysis
                    },
                    legend: {
                        position: "bottom"
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        type: "line",
                        style: "smooth"
                    },
                    series: $scope.SalePurchaseAnalysisData.series,
                    
                    valueAxis: {
                        // labels: {
                        //     format: "{0}"
                        // },
                        labels: {
                            //template: "#= kendo.toString(value, 'n0') #"
                            template: function (e) {
                                return $scope.convertNo(e.value);
                            }
                        },
                        line: {
                            visible: false
                        },
                        axisCrossingValue: -10
                    },
                    categoryAxis: {
                        categories: $scope.SalePurchaseAnalysisData.categories,
                        majorGridLines: {
                            visible: false
                        },
                        labels: {
                            rotation: "auto"
                        }
                    },
                    tooltip: {
                        visible: true,
                        format: "{0}",
                        //template: "#= series.name #: #= value #",
                        template: function (e) {
                            return e.series.name + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });
                $("#salesPurchaseAnalysisChart2").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.SalesPurchaseAnalysis
                    },
                    legend: {
                        position: "bottom"
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        type: "line",
                        style: "smooth"
                    },
                    series: $scope.SalePurchaseAnalysisData.series,
                    valueAxis: {
                        // labels: {
                        //     format: "{0}"
                        // },
                         labels: {
                            //template: "#= kendo.toString(value, 'n0') #"
                            template: function (e) {
                                return $scope.convertNo(e.value);
                            }
                        },
                        line: {
                            visible: false
                        },
                        axisCrossingValue: -10
                    },
                    categoryAxis: {
                        categories: $scope.SalePurchaseAnalysisData.categories,
                        majorGridLines: {
                            visible: false
                        },
                        labels: {
                            rotation: "auto"
                        }
                    },
                    tooltip: {
                        visible: true,
                        format: "{0}",
                        //template: "#= series.name #: #= value #"
                        template: function (e) {
                            return e.series.name + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });

            }

            $scope.mostSalesItemsGroupFun = function () {

                $("#mostSellingGroupChart").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.MostPurchasingGroups
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        labels: {
                            visible: true,
                            background: "transparent",
                            //  template: "#= category #: \n #= value#",
                            template: function (e) {
                                return e.category + ": \n" + $scope.convertNo(e.value);
                            }
                        }
                    },
                    series: [{
                        type: "pie",
                        startAngle: 150,
                        data: $scope.MostSellingItemsGroups,
                    }],
                    tooltip: {
                        visible: true,
                        format: "{0}",
                        template: function (e) {
                            return e.category + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });
                $("#mostSellingGroupChart2").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.MostPurchasingGroups
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        labels: {
                            visible: true,
                            background: "transparent",
                            // template: "#= category #: \n #= value#"
                            template: function (e) {
                                return e.category + ": \n" + $scope.convertNo(e.value);
                            }
                        }
                    },
                    series: [{
                        type: "pie",
                        startAngle: 150,
                        data: $scope.MostSellingItemsGroups,
                    }],
                    tooltip: {
                        visible: true,
                        format: "{0}",
                        template: function (e) {
                            return e.category + ": \n" + $scope.convertNo(e.value);
                        }
                    }
                });
            }

            $scope.changeview1 = function (val) {
                $scope.view1 = val;
            }

            $scope.changeview2 = function (val) {
                $scope.view2 = val;
            }

            $scope.changeview3 = function (val) {
                $scope.view3 = val;
            }

            $scope.changeview4 = function (val) {
                $scope.view4 = val;
            }

            $scope.Init = function () {

                $scope.view1 = 0;
                $scope.view2 = 0;
                $scope.view3 = 0;
                $scope.view4 = 0;

                $scope.dashcounts = [];
                MainService.PurchaseDashboardCounts().then(function (response) {
                    $scope.dashcounts = response.data;
                }, function () { })

                $scope.DailySales1 = [];
                MainService.GetDailyPurchaseTableDashboard().then(function (response) {
                    $scope.DailySales1 = response.data;
                    $scope.DailySales1Qty = 0;
                    $scope.DailySales1Value = 0;
                    angular.forEach($scope.DailySales1, function (e) {
                        $scope.DailySales1Qty = $scope.DailySales1Qty + e.Quantity;
                        $scope.DailySales1Value = $scope.DailySales1Value + e.Value;
                    })
                }, function () { })

                $scope.DailySales2 = [];
                MainService.GetDailyPurchaseTableDashboard2().then(function (response) {
                    $scope.DailySales2 = response.data;
                    $scope.DailySales2Qty = 0;
                    $scope.DailySales2Value = 0;
                    angular.forEach($scope.DailySales2, function (e) {
                        $scope.DailySales2Qty = $scope.DailySales2Qty + e.Quantity;
                        $scope.DailySales2Value = $scope.DailySales2Value + e.Value;
                    })
                }, function () { })

                $scope.MonthlySales1 = [];
                MainService.GetMonthlyPurchaseTableDashboard().then(function (response) {
                    $scope.MonthlySales1 = response.data;
                    $scope.MonthlySales1Qty = 0;
                    $scope.MonthlySales1Value = 0;
                    angular.forEach($scope.MonthlySales1, function (e) {
                        $scope.MonthlySales1Qty = $scope.MonthlySales1Qty + e.Quantity;
                        $scope.MonthlySales1Value = $scope.MonthlySales1Value + e.Value;
                    })
                }, function () { })

                $scope.MonthlySales2 = [];
                MainService.GetMonthlyPurchaseTableDashboard2().then(function (response) {
                    $scope.MonthlySales2 = response.data;
                    $scope.MonthlySales2Qty = 0;
                    $scope.MonthlySales2Value = 0;
                    angular.forEach($scope.MonthlySales2, function (e) {
                        $scope.MonthlySales2Qty = $scope.MonthlySales2Qty + e.Quantity;
                        $scope.MonthlySales2Value = $scope.MonthlySales2Value + e.Value;
                    })
                }, function () { })

                $scope.TopMonthlyCustomers = [];
                MainService.TopMonthlySuppliers().then(function (response) {
                    $scope.TopMonthlyCustomers = response.data;
                    $scope.TopMonthlyCustomersValue = 0;
                    angular.forEach($scope.TopMonthlyCustomers, function (e) {
                        $scope.TopMonthlyCustomersValue = $scope.TopMonthlyCustomersValue + e.Value;
                    })
                }, function () { })

                $scope.TopYearlyCustomers = [];
                MainService.TopYearlySuppliers().then(function (response) {
                    $scope.TopYearlyCustomers = response.data;
                    $scope.TopYearlyCustomersValue = 0;
                    angular.forEach($scope.TopYearlyCustomers, function (e) {
                        $scope.TopYearlyCustomersValue = $scope.TopYearlyCustomersValue + e.Value;
                    })
                }, function () { })

                $scope.TopMonthlyProducts = [];
                MainService.TopProductTablePurchaseMonthlyDashboard().then(function (response) {
                    $scope.TopMonthlyProducts = response.data;
                    $scope.TopMonthlyProductsValue = 0;
                    angular.forEach($scope.TopMonthlyProducts, function (e) {
                        $scope.TopMonthlyProductsValue = $scope.TopMonthlyProductsValue + e.Quantity;
                    })
                }, function () { })

                $scope.TopQuarterProducts = [];
                MainService.TopProductTablePurchaseQuarterDashboard().then(function (response) {
                    $scope.TopQuarterProducts = response.data;
                    $scope.TopQuarterProductsValue = 0;
                    angular.forEach($scope.TopQuarterProducts, function (e) {
                        $scope.TopQuarterProductsValue = $scope.TopQuarterProductsValue + e.Quantity;
                    })
                }, function () { })


                $scope.Top10Customers = [];
                MainService.Top10Suppliers().then(function (response) {
                    $scope.Top10Customers = response.data;
                    if ($scope.Top10Customers.length > 0) {
                        $scope.top10CustomersFun();
                    }
                }, function () { })

                $scope.MostSellingItems = [];
                MainService.MostPurchaseItems().then(function (response) {
                    $scope.MostSellingItems = response.data;
                    if ($scope.MostSellingItems.length > 0) {
                        $scope.mostSalesItemsFun();
                    }
                }, function () { })

                $scope.MonthlySalesChartData = {};
                MainService.MonthlyPurchaseChart().then(function (response) {
                    $scope.MonthlySalesChartData = response.data;
                    if ($scope.MonthlySalesChartData != null) {
                        $scope.MonthlySalesChartFun();
                    }
                }, function () { })

                $scope.SalePurchaseAnalysisData = {};
                MainService.SalePurchaseAnalysis().then(function (response) {
                    $scope.SalePurchaseAnalysisData = response.data;
                    if ($scope.SalePurchaseAnalysisData != null) {
                        $scope.SalePurchaseAnalysisFun();
                    }
                }, function () { })

                $scope.MostSellingItemsGroups = [];
                MainService.MostPurchaseItemsGroup().then(function (response) {
                    $scope.MostSellingItemsGroups = response.data;
                    if ($scope.MostSellingItemsGroups.length > 0) {
                        $scope.mostSalesItemsGroupFun();
                    }
                }, function () { })


                $scope.catFilter = {
                    DateFrom: new Date(),
                    DateTo: new Date(),
                }
                $scope.proFilter = {
                    DateFrom: new Date(),
                    DateTo: new Date(),
                }

            }
            $scope.Init();


            $scope.openCategoryFilterModal = function () {
                $('#categoryFilterModal').modal('show');
            }

            $scope.filterProductCategoryDate = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var temp = {
                    FromDate: $scope.extractDate($scope.catFilter.DateFrom),
                    ToDate: $scope.extractDate($scope.catFilter.DateTo),
                }

                MainService.GetDailyPurchaseTableDashboardByDate(temp).then(function (response) {
                    if (response.data != null && response.data.length > 0) {
                        $('#categoryFilterModal').modal('hide');
                        $scope.DailySales1 = response.data;
                          $scope.DailySales1Qty = 0;
                    $scope.DailySales1Value = 0;
                    angular.forEach($scope.DailySales1, function (e) {
                        $scope.DailySales1Qty = $scope.DailySales1Qty + e.Quantity;
                        $scope.DailySales1Value = $scope.DailySales1Value + e.Value;
                    })
                        $scope.view1 = 0;
                    } else {
                        toastr.error("No Data Found");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });

            }

            $scope.openProductFilterModal = function () {
                $('#productFilterModal').modal('show');
            }

            $scope.filterProductDate = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var temp = {
                    FromDate: $scope.extractDate($scope.proFilter.DateFrom),
                    ToDate: $scope.extractDate($scope.proFilter.DateTo),
                }

                MainService.GetDailyPurchaseTableDashboard2ByDate(temp).then(function (response) {
                    if (response.data != null && response.data.length > 0) {
                        $('#productFilterModal').modal('hide');
                        $scope.DailySales2 = response.data;

                         $scope.DailySales2Qty = 0;
                        $scope.DailySales2Value = 0;
                        angular.forEach($scope.DailySales2, function (e) {
                            $scope.DailySales2Qty = $scope.DailySales2Qty + e.Quantity;
                            $scope.DailySales2Value = $scope.DailySales2Value + e.Value;
                        })

                        $scope.view2 = 0;
                    } else {
                        toastr.error("No Data Found");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });



            }


        }])
